module.exports = __webpack_public_path__ + "static/media/complete-desktop.c255adbb.svg";